export const ArrowRight: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#000",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="10"
    fill="none"
    viewBox="0 0 14 10"
    color={color}
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M9.083 8.75 12.833 5l-3.75-3.75"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M1.166 5h11.25"
    ></path>
  </svg>
);
